import { render } from "./UserSummary.vue?vue&type=template&id=6b081d0f&ts=true"
import script from "./UserSummary.vue?vue&type=script&lang=ts"
export * from "./UserSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserInfo/UserSummary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b081d0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b081d0f', __exports__)) {
    api.reload('6b081d0f', __exports__)
  }
  
  module.hot.accept("./UserSummary.vue?vue&type=template&id=6b081d0f&ts=true", () => {
    api.rerender('6b081d0f', render)
  })

}


export default __exports__